<template>
  <el-dialog :visible="visible" fullscreen append-to-body @close='closeDialog' class='children-dialog'>
    <children-tabs :default-children='children' :current-row="currentRow" :formRuntimeDialog="formRuntimeDialog"/>
  </el-dialog>
</template>

<script>
import ChildrenTabs from './children-tabs.vue'
export default {
  name: 'children-dialog',
  props: ['children', 'currentRow', 'visible', 'formRuntimeDialog'],
  components: {
    ChildrenTabs
  },
  methods: {
    closeDialog () {
      this.$emit('close')
    }
  }
}
</script>
<style lang="scss">
.children-dialog {
  .el-dialog__header {
    padding-top: 0;
  }
  .pagination-list > .el-main {
    height: 100%;
    >.content{
     height: 500px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/report/runtime/children-dialog.vue